<template>
  <div class="catalog-filters main-filters-container" :class="getFiltersVisiblity">
    <CatalogSearchField
      :catalog="catalog"
      :class="'hide-small'"
    />
    <div v-if="catalog !== 'authors'" class="catalog-filters__container">
      <div class="catalog-filters__mobile-header show-small">
        <p class="type-h3 no-bottom-margin">Add Filters</p>
        <button type="button" class="type-link type-x-small catalog-filters__clear margin-left-m" @click="clearActiveAttributes">Clear
          Filters</button>
        <button type="button" class="show-small catalog-filters__close" @click="toggleFilters">
          <svg width="15px" height="15px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Expand</title>
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g fill-rule="nonzero" fill="#000000">
                <path d="M4,4 L1,4 L1,6 L4,6 L4,9 L6,9 L6,6 L9,6 L9,4 L6,4 L6,1 L4,1 L4,4 Z"></path>
              </g>
            </g>
          </svg>
        </button>
      </div>
      <p class="type-small color-silver add-small-bottom-margin hide-small">Filter by:</p>
      <ul class="catalog-filters__list type-small unstyled-list">
        <CatalogAttribute
          v-for="item in sortedFiltersByCatalog"
          :item="item"
          :key="item.Id"
          :catalog="catalog"
        />
      </ul>
    </div>
    <div class="catalog-filters__mobile-footer show-small">
      <button type="button" class="btn" @click="toggleFilters">See all titles</button>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex';

import {
  GET_CATALOG_ITEMS,
  GET_FILTERED_ITEMS,
  GET_FILTERED_AUTHORS,
  GET_CATEGORIES,
  GET_CATALOG_LOCALSTORAGE,
} from '../vuex/modules/catalog/mutations';
// import { SET_CATALOG_LOCALSTORAGE } from '../vuex/modules/catalog/mutations';

import CatalogAttribute from './CatalogAttribute.vue';
import CatalogSearchField from './CatalogSearchField.vue';

import _ from 'lodash';

export default {
  name: 'CatalogFilters',
  props: ['catalog'],
  components: {
    CatalogAttribute,
    CatalogSearchField,
  },
  data() {
    return {
      // searchTerm: '',
      placeholder: `Search in ${this.catalog}`,
      selectedCatalogCollections: [],
      queryParamCatalog: null,
      isVisible: true,
    }
  },
  mounted() {
    this.getLocalStorage();

    // define the catalog we are using
    this.$store.commit('setApiEndpoint', this.catalog);
    const isUk = document.body.classList.contains('domain_uk');
    this.$store.commit('setLocale', isUk)

    this.GET_CATEGORIES()
      .then(() => {
        this.setCatalogCollection();
        this.getQueryParams();
      });

    window.addEventListener('resize', _.debounce(this.setFilterDisplayForScreenSize, 50));

    this.setFilterDisplayForScreenSize();
  },

  watch: {
    // watcher is used to add a fixed position to the body
    // when the filters are visible on mobile, since it
    // takes over the whole viewport.
    filtersVisible(newVal, oldVal) {
      if (newVal == true) {
        document.body.classList.add('js-filters-open');
      } else {
        document.body.classList.remove('js-filters-open');
      }
    },
  },

  methods: {
    ...mapActions({
      GET_CATALOG_ITEMS,
      GET_FILTERED_ITEMS,
      GET_FILTERED_AUTHORS,
      GET_CATEGORIES,
      // SET_CATALOG_LOCALSTORAGE,
      GET_CATALOG_LOCALSTORAGE,
    }),

    getLocalStorage() {
      let storedFilters = null;
      if (this.activeCatalog == 'perform') {
        storedFilters = localStorage.getItem('performStore');
      } else if (this.activeCatalog == 'shop') {
        storedFilters = localStorage.getItem('shopStore');
      } else if (this.activeCatalog == 'authors') {
        storedFilters = localStorage.getItem('authorStore');
      }

      if (typeof storedFilters !== null) {
        this.GET_CATALOG_LOCALSTORAGE();
        // console.log('getting local storage state');
      }
    },

    toggleFilters() {
      const visibility = !this.filtersVisible;
      this.$store.commit('setFiltersVisiblity', visibility);
    },

    // method called on window resize event
    setFilterDisplayForScreenSize() {
      const visibility = window.matchMedia('(min-width: 769px)').matches;

      this.$store.commit('setFiltersVisiblity', visibility);
    },

    // once the initial GET_CATEGORIES is returned, we then set the current catalog to state,
    // based on the catalog param that is passed. This catalog state is used in subsequent
    // API requests.
    setCatalogCollection() {
      switch (this.catalog) {
        case 'authors':
          this.selectedCatalogCollections = [...this.authorCollections];
          break;
        case 'perform':
          this.selectedCatalogCollections = [...this.performCollections];
          break;
        case 'shop':
          this.selectedCatalogCollections = [...this.shopCollections];
          break;
      }

      this.$store.commit('setSelectedCatalogCollections', this.selectedCatalogCollections);
    },


    // do the API call.
    getFilteredResults() {
      const $vm = this;

      const filterAction = this.catalog == 'authors' ? this.GET_FILTERED_AUTHORS : this.GET_FILTERED_ITEMS;

        filterAction()
          .then(function () {
            $vm.$store.commit('buildNextLinks', $vm.totalPages);
            $vm.$store.commit('buildPrevLinks');
          })
    },

    // helper method to clear all active attributes, which triggers
    // a new API request with no attributes in the params. Only
    // available for mobile
    clearActiveAttributes() {
      this.$store.commit('clearActiveAttributes');
      this.$store.commit('clearActiveCastSize', this.activeCastSize);
      this.getFilteredResults();
    },

    // if no parameters are detected, this method is called to do an API
    // call on page 1 of the results.
    getInitialResults() {
      this.$store.commit('setPageNumber', this.currentPage);
      this.getFilteredResults();
    },

    // helper method to determine which catalog id to pass into the query
    // parameter if it is a URL parameter.
    getCatalogById(param) {
      // console.log(param);
      // console.log(this.selectedCatalogCollections);
      return this.selectedCatalogCollections.find(cat => cat.Id == param);
    },

    // helper method to determine whether the passed string exists in the passed
    // longer string. In this case, search for a string in a url.
    isInUrl(thingToSearch, term) {
      return (thingToSearch.indexOf(term) > - 1) ? true : false;
    },


    // if the passed string contains either of the terms, then combine them
    // in the search API query on the initial page load.
    setQueryField(href) {
      // check for a query param
      if (this.isInUrl(href, 'keyword')) {
        return 'keyword';
      } else if (this.isInUrl(href, 'catalogId')) {
        return 'catalogId';
      } else if (this.isInUrl(href, 'query')) {
        return 'query';
      } else {
        return null;
      }
    },

    // before doing the initial search API request, this method looks for
    // any passed parameters, whether for a keyword query or catalogId
    // which would be passed along from the search boxes in the header
    // or the catalog landing pages.
    getQueryParams() {
      const href = window.location.href;
      const field = this.setQueryField(href);
      const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
      const string = reg.exec(href);
      // set the current query term if it is passd into the URL
      if (field == 'keyword' || field == 'query') {
        this.searchTerm = decodeURIComponent(string[1]);
        this.$store.commit('setSearchTerm', this.searchTerm);
        this.getFilteredResults();
        // set the current catalog Id if it is passd into the URL
      } else if (field == 'catalogId') {
        const currentParams = Object.fromEntries(new URLSearchParams(window.location.search).entries());
        this.queryParamCatalog = parseInt(currentParams.catalogId);
        const activeCat = this.getCatalogById(this.queryParamCatalog);
        if (activeCat) {
          this.$store.commit('setActiveCategory', { id: activeCat.Id, name: activeCat.Name });
        }
        this.getFilteredResults();
      } else {
        // if no parameters passed in the url, do the API call.
        this.getInitialResults();
      }
    },
  },

  computed: {
    ...mapState({
      currentPage: state => state.catalogStore.currentPage,
      endpoint: state => state.catalogStore.API_SEARCH_ENDPOINT,
      activeCategory: state => state.catalogStore.activeCategory,
      filtersVisible: state => state.catalogStore.filtersVisible,
      activeAttributes: state => state.catalogStore.activeAttributes,
      activeCastSize: state => state.catalogStore.activeCastSize,
    }),

    ...mapGetters([
      'totalPages',
      'authorCollections',
      'performCollections',
      'shopCollections',
      'availableCategories',
      'sortedFilters',
      'maleCastSize',
      'femaleCastSize',
    ]),


    sortedFiltersByCatalog() {
      if (this.catalog == 'shop') {
        // if shop, then we remove Available Resources and the Cast Size attributes
        return this.sortedFilters.filter(item => {
          return item.Id !== 'available-resources' &&
            item.Id !== 'performance-group' &&
            item.Id !== 'cast-size';
        })
      }

      if (this.catalog == 'perform') {
        // if shop, then we remove Available Resources and the Cast Size attributes
        return this.sortedFilters.filter(item => {
          return item.Id !== 'product-type' &&
            item.Id !== 'performance-group';
        })
      }
      return this.sortedFilters;
    },


    // sets the visiblity class on the filters container for
    // mobile view.
    getFiltersVisiblity() {
      return this.filtersVisible ? '' : 'js-is-hidden';
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CatalogFilters.vue